<input type="radio" [name]="name" [checked]="checkedStatus"  (change)="getvalue($event)" [value]="value"
 kendoRadioButton />
{{text}}
